define(function(require) {
  const ViewManager = require('civicsUtils/view_manager');
  const AvailableFeatures = require('civicsUtils/available_features');

  return {
    isClosed: function(closedStatusArray, statusToCheck, isClosedInstrument) {
        if( AvailableFeatures.InstrumentClosedFlag() )
            return isClosedInstrument != null ? isClosedInstrument : false;

      for( var i = 0; closedStatusArray && i < closedStatusArray.length; i++){
        if( closedStatusArray[i] != null && closedStatusArray[i].toUpperCase() == statusToCheck.toUpperCase()){
          return true;
        }
      }
      return false;
    },
    isCustomer: function(activeProfiles) {
      for( var i = 0; activeProfiles && i < activeProfiles.length; i++){
        if( activeProfiles.models[i].get('name').toUpperCase() == 'CUSTOMER'){
          return true;
        }
      }
      return false;
    },
    convertToInstrumentView: function(instType, json) {
      var instrumentJson = {};

      if ( instType ){
        instType = instType.toUpperCase();
        if ( instType == "PLANNING" ) {
          instrumentJson.instrumentType = "PLANNINGAPPLICATION";
          this.mapApplicationData ( instrumentJson, json );
        }
        else if ( instType == "BUILDING" ) {
          instrumentJson.instrumentType = "BUILDINGAPPLICATION";
          this.mapApplicationData ( instrumentJson, json );
        }
        else if ( instType == "PROJECT" ) {
          instrumentJson.instrumentType = "PROJECTAPPLICATION";
          this.mapApplicationData ( instrumentJson, json );
        }
        else if ( instType == "CODEENFORCEMENT" ) {
          instrumentJson.instrumentType = "CASE";
          this.mapApplicationData ( instrumentJson, json );
        }
        else if ( instType == "BUSINESSLICENSE" ) {
          instrumentJson.instrumentType = "BUSINESSLICENSE";
          this.mapApplicationData ( instrumentJson, json );
        }
        else if ( instType == "TRADELICENSE" ) {
          instrumentJson.instrumentType = "TRADELICENSE";
          this.mapApplicationData ( instrumentJson, json );
        }
        else if ( instType == "USE" ) {
          instrumentJson.instrumentType = "USEAPPLICATION";
          this.mapApplicationData ( instrumentJson, json );
        }
        else if ( instType == "SERVICEREQUEST" ) {
          instrumentJson.instrumentType = "ServiceRequest";
          this.mapApplicationData ( instrumentJson, json );
          instrumentJson.statusDescription = (json.status && json.status.trim().length > 0) ? i18n.t('CIVICS.COMMON.CLOSED') : i18n.t('CIVICS.COMMON.OPEN');
          instrumentJson.addedDateTime = json.callDateTime;
        }
        else if ( instType == "INSTRUMENT" ) {
          this.mapApplicationData ( instrumentJson, json );
          instrumentJson._cdrType = json.instrumentType;
          instrumentJson.instrumentType = "PortalInstrument";
          instrumentJson.productFamily = 'Portal';
          instrumentJson.computedDescription = json.dataTypeCodeDescription;
          instrumentJson.instrumentName = json.dataTypeCodeDescription;
          instrumentJson.statusDescription = i18n.t('CIVICS.COMMON.OPEN');
        }
        else if ( instType == "SCENARIO" ) {
          instrumentJson.instrumentType = "PortalScenario";
          this.mapApplicationData ( instrumentJson, json );
        }
      }
      return instrumentJson;
    },
    isElectronicPlanSupportedByInstType: function(instrumentType) {
      if (!instrumentType) {
        return false;
      }

      instrumentType = instrumentType.toLowerCase();

      let isElectronicPlanSupported = (instrumentType === 'building'  || instrumentType === 'planning'
      || instrumentType === 'project' ||  instrumentType === 'use');

      return isElectronicPlanSupported;
    },
    mapApplicationData: function(dest, src) {
      for (var prop in src) {
          dest[prop] = src[prop];
        }

      dest.instrumentName = src.applicationName;
      if (src.applicationType)dest.instrumentSubType = src.applicationType.code;
      dest.instrumentNumber = src.applicationNumber;
      dest.instrumentDateTime = src.applicationDateTime;
      if (src.applicationType){
        dest.computedDescription = Handlebars.helpers['global:computedDescription'](src.applicationType.portalDescription, src.applicationType.description);
      }
      else if( src.requestType ){
          dest.computedDescription = Handlebars.helpers['global:computedDescription'](src.requestType.portalDescription, src.requestType.description);
      }
    },
    camelify: function(instrumentType) {
      var instType = instrumentType.toUpperCase();

      if ( instType == "CODEENFORCEMENT" ) {
        return "codeEnforcement";
      }
      else if ( instType == "BUSINESSLICENSE" ) {
        return "businessLicense";
      }
      else if ( instType == "TRADELICENSE" ) {
        return "tradeLicense";
      }

      return instrumentType;
    },
    // get cdr service type from core view instrument type
    getCDRType: function(instrumentType, camelCase) {
      var cdrType;
      if ( instrumentType ){
        var instType = instrumentType.toUpperCase();
        //when comparing to globalConfig, we need camel case from the instruments that are more than one word long.
        if(camelCase){
          if ( instType == "CASE" ) {
            return "codeEnforcement";
          }
          else if ( instType == "BUSINESSLICENSE" ) {
            return "businessLicense";
          }
          else if ( instType == "TRADELICENSE" ) {
            return "tradeLicense";
          }
        }

        if ( instType == "PLANNINGAPPLICATION" ) {
          return "planning";
        }
        else if ( instType == "BUILDINGAPPLICATION" ) {
          return "building";
        }
        else if ( instType == "PROJECTAPPLICATION" ) {
          return "project";
        }
        else if ( instType == "CASE" ) {
          return "codeenforcement";
        }
        else if ( instType == "BUSINESSLICENSE" ) {
          return "businesslicense";
        }
        else if ( instType == "TRADELICENSE" ) {
          return "tradelicense";
        }
        else if ( instType == "USEAPPLICATION" ) {
          return "use";
        }
        else if ( instType == "SERVICEREQUEST" ) {
          return "servicerequest";
        }
      }
      return cdrType;
    },
    // get cdr service type from core view instrument type
    getInstrumentType: function(instrumentTypeId) {
      var cdrType;
      switch(instrumentTypeId){
        case 2:
          cdrType = 'use';
        break;
        case 3:
          cdrType = 'planning';
        break;
        case 4:
          cdrType = 'codeenforcement';
        break;
        case 5:
          cdrType = 'tradelicense';
        break;
        case 6:
          cdrType = 'businesslicense';
        break;
        case 7:
          cdrType = 'building';
        break;
        case 8:
          cdrType = 'project';
        break;
        case 9:
          cdrType = 'servicerequest';
        break;
        default:
          cdrType = '';
        break;
      }
      return cdrType;
    },
    isCDR: function(dataType) {
      if ( dataType ){
        dataType = dataType.toUpperCase();
           if( dataType ==  "PLANNINGAPPLICATION" ||
              dataType ==  "BUILDINGAPPLICATION" ||
              dataType ==  "PROJECTAPPLICATION" ||
              dataType ==  "CASE" ||
              dataType ==  "BUSINESSLICENSE" ||
              dataType ==  "TRADELICENSE" ||
              dataType ==  "USEAPPLICATION" ) {
            return true;
        }// SUPPORT older version
        else if ( dataType ==  "PLANNING" ||
              dataType ==  "BUILDING" ||
              dataType ==  "PROJECT" ||
              dataType ==  "CODEENFORCEMENT" ||
              dataType ==  "BUSINESSLICENSE" ||
              dataType ==  "TRADELICENSE" ||
              dataType ==  "USE" ) {
            return true;
        }
      }
      return false;
    },
    isPrimaryContact: function(contacts, contactIdToCheck) {
      for( var i = 0; contacts && i < contacts.length; i++){
        if( contacts.models[i].isPrimary == "True"){
          return contacts.models[i].contact.id == contactIdToCheck ? true : false;
        }
      }
      return false;
    },
    isProvider: function(activeProfiles) {
      // 2016-01-26 PL:   True if activeProfiles has "Provider" but not "Customer"
      var globalConfig = ViewManager.globalConfig();
      if( globalConfig.get( "useServiceProviders" ) == true ){    //can only be true if turned on in the config
        if (!this.isCustomer(activeProfiles)) {
          for( var i = 0; activeProfiles && i < activeProfiles.length; i++){
            if( activeProfiles.models[i].get('name').toUpperCase() == 'PROVIDER'){
              return true;
            }
          }
        }
      }
      return false;
    },
    isPublic: function(activeProfiles) {
      // User is public if they aren't a Customer or Provider
      if (this.isCustomer(activeProfiles) || this.isProvider(activeProfiles)) {
        return false;
      }
      return true;
    },
    isWithdrawalAllowed: function(instType, status, isClosedInstrument) {
      var globalConfig = ViewManager.globalConfig();
      var allow = false;
      var cdrType = this.getCDRType(instType, true);
      if (status) {
        var isWithdrawAllowed = globalConfig.get(cdrType+'.allowWithdraw');
        var isInstrumentStatusClosed = this.isClosed(globalConfig.get(cdrType+'.closedStatus'), status, isClosedInstrument);
        var isInstrumentPendingWithdraw = globalConfig.get(cdrType+'.pendingWithdrawStatus') && globalConfig.get(cdrType+'.pendingWithdrawStatus').toLowerCase() == status.toLowerCase();

        allow = isWithdrawAllowed && !isInstrumentStatusClosed && !isInstrumentPendingWithdraw;
      }
      return allow;
    },
    isInstrumentStatusClosed: function(instType, status, isPortalClosed ) {
      var globalConfig = ViewManager.globalConfig();
      var isInstrumentStatusClosed = true;
      var cdrType = this.getCDRType(instType, true);

      if (status) {
        isInstrumentStatusClosed = this.isClosed(globalConfig.get(cdrType+'.closedStatus'), status, isPortalClosed);
      }

      return isInstrumentStatusClosed;
    },
    isElectronicPlanSupportedByInstType: function(instrumentType) {
      if (!instrumentType) {
        return false;
      }

      instrumentType = instrumentType.toLowerCase();

      let isElectronicPlanSupported = (instrumentType === 'building'  || instrumentType === 'planning'
      || instrumentType === 'project' ||  instrumentType === 'use');

      return isElectronicPlanSupported;
    },
    getAttachmentCatalog: function (instType) {
      var globalConfig = ViewManager.globalConfig();
      var attachmentSetup = globalConfig.get('attachments');
      var catalog = "";

      if(instType) {

        var instTypeCatalog = "";

        switch(instType.toUpperCase()){
          case "BUSINESSLICENSE":
          instTypeCatalog = 'licenseCatalog';
          break;
          case "TRADELICENSE":
          instTypeCatalog = 'tradeCatalog';
          break;
          case "BUILDING":
          instTypeCatalog = 'buildingCatalog';
          break;
          case "PROJECT":
          instTypeCatalog = 'projectCatalog';
          break;
          case "PLANNING":
          instTypeCatalog = 'planningCatalog';
          break;
          case "USE":
          instTypeCatalog = 'useCatalog';
          break;
          case "CODEENFORCEMENT":
          instTypeCatalog = 'caseCatalog';
          break;
          case "SERVICEREQUEST":
          instTypeCatalog = 'crmCatalog';
          break;
          default:
          instTypeCatalog = '';
          break;
        }

        catalog = ( attachmentSetup.get(instTypeCatalog) && attachmentSetup.get(instTypeCatalog).length > 0 ) ? attachmentSetup.get(instTypeCatalog) : attachmentSetup.get('defaultCatalog');
      }

      return catalog;
    },
    setElectronicPlanLogoutURL: function(ePlanURL){
      let index = ePlanURL.indexOf('?');
      let ePlanLogoutURL = index > 0 ? ePlanURL.substring(0, index + 1) + 'invalidate' :
                 ePlanURL + 'invalidate';
      App.sessionStorage.set('CIVICS', 'EPLAN_LOGOUT_URL', ePlanLogoutURL);
    },
    //useInstrumentDetailConfig -
    buildModifiedInstDescription: function(model, instrumentDetailTargetpage, linkIDPrefix) {
      let instrumentLinkDescription = '<span class="instrument-number">' + model.get('instrumentNumber') + '</span>';
      let instrumentPortalDescription = '';
      let locationLines = '';
      let instrumentLocationDescription = '';
      let instrumentTitleDescription = '';

      if (model.get('haveAccess')){
        let instrumentNumber = model.get('instrumentNumber');
        let ariaLabel = i18n.t('CIVICS.COMMON.VIEW_RECORD', { recordId: instrumentNumber });
        instrumentLinkDescription = '<a id="'+linkIDPrefix+'link_' + model.get('instrumentType') + '_' + instrumentNumber + '_OneTimePayment" class="instrument-link link-primary" href="' + instrumentDetailTargetpage.urlPath({
          intdetails: model.get('instrumentType'),
          intid: model.get('id')
        }) + '" target="_blank" aria-label="' + ariaLabel + '">' + instrumentNumber + '</a>';
      }

      if (model.get('portalDescription')) {
        instrumentPortalDescription +=  '<span class="portal-description">' + Handlebars.helpers['global:sanitize'](i18n.t('CIVICS.ONE_TIME_PAYMENT.INSTRUMENT_DESCRIPTION',{ portalDescription: model.get('portalDescription') }), { hash: { allowedTags: '' } }) + '</span>';
      }

      if (model.get('instrumentType').toLowerCase() !== 'tradelicense') {
        let locationLine1 = model.get('locationLine1');
        let locationLine2 = model.get('locationLine2');

        if (locationLine1 && locationLine1.trim() !== '')
           locationLines += locationLine1;

        if (locationLine2 && locationLine2.trim() !== '')
           locationLines += locationLine2;
      }

      if (locationLines !== '') {
        instrumentLocationDescription = '<span class="location-description">' + i18n.t('CIVICS.ONE_TIME_PAYMENT.LOCATION_DESCRIPTION',{location: locationLines}) + '</span>';
      }

      if (model.get('instrumentName') && AvailableFeatures.AddInstrumentTitleToPayment()) {
        instrumentTitleDescription = '<span class="instrument-title">' + Handlebars.helpers['global:sanitize'](model.get('instrumentName'), { hash: { allowedTags: '' } }) + '</span> ';
      }

      let titlePortalDescription = '<div class="title-portal-desc">' + instrumentTitleDescription + instrumentPortalDescription + '</div>';

      let instrumentTextDescription = '<div class="instrument-text-description">'+ titlePortalDescription + instrumentLocationDescription  +'</div>'

      return instrumentLinkDescription + instrumentTextDescription;
    }
  };
});
